<template>
  <div class="wrapper">
    <dashboard-bar refreshButton />
    <div class="wrapper-trash">
      <div class="row mb-3">
        <div class="col-12">
          <ul class="nav-menu">
            <li @click="changeOption($event, 1)">
              <a class="menu-active" id="company-menu">{{
                $t('trash.actionsMenu.title')
              }}</a>
            </li>
            <li @click="changeOption($event, 2)">
              <a id="company-users">{{ $t('trash.answersMenu.title') }}</a>
            </li>
          </ul>
        </div>
      </div>
      <perfect-scrollbar>
        <div class="content-tab" v-show="step === 1">
          <b-table
            :items="itemsActions"
            :fields="actionsFields"
            responsive="sm"
          >
            <template v-slot:thead-top>
              <b-tr>
                <b-th style="border: none" colspan="3"
                  ><span class="sr-only"></span
                ></b-th>
                <b-th style="width: 50px; border: none"></b-th>
              </b-tr>
            </template>
            <template v-slot:cell(updatedAt)="row">
              {{ dateFormat(row.item.updatedAt) }}
            </template>
            <template
              v-slot:cell(restore)="row"
              v-if="userProfile.permissions.trash.undo_action"
            >
              <div class="text-center">
                <button
                  class="btn btn-outline-primary"
                  @click="restore('action', row.item._id)"
                >
                  <i class="fas fa-trash-restore-alt"></i>
                </button>
              </div>
            </template>
          </b-table>
          <paginate
            :pageCount="this.trash.actions.documents"
            :clickHandler="changePageActions"
            :prevText="'‹'"
            :nextText="'›'"
            :activeClass="'active'"
            :containerClass="'pagination b-pagination'"
            :pageClass="'page-item'"
          >
          </paginate>
        </div>
      </perfect-scrollbar>
      <perfect-scrollbar>
        <div class="content-tab" v-show="step === 2">
          <div class="row">
            <div class="col-3 mt-3">
              <div class="search-actions">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('trash.answersMenu.searchInput')"
                  v-model="filter"
                  @keyup="searchByFilter"
                />
                <button @click="cleanFilter" class="btn btn-outline-primary">
                  {{ $t('trash.answersMenu.searchButton') }}
                </button>
              </div>
            </div>
          </div>
          <b-table
            :items="itemsAnswers"
            :fields="answersFields"
            responsive="sm"
            :busy="loading"
          >
            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner type="grow" class="align-middle"></b-spinner>
              </div>
            </template>
            <template v-slot:thead-top id="table-answer">
              <b-tr>
                <b-th style="border: none" colspan="5"
                  ><span class="sr-only"></span
                ></b-th>
                <b-th style="width: 50px; border: none"></b-th>
              </b-tr>
            </template>
            <template v-slot:cell(actionId)="row">
              {{ row.item.actionId.name }}
            </template>
            <template v-slot:cell(answerId)="row">
              {{ row.item.answerId.controlId }}
            </template>
            <template v-slot:cell(updatedAt)="row">
              {{ dateFormat(row.item.updatedAt) }}
            </template>
            <template v-slot:cell(userId)="row">
              {{ checkUser(row.item.userId) }}
            </template>
            <template v-slot:cell(deletedBy)="row">
              {{ row.item.deletedBy }}
            </template>
            <template v-slot:cell(client)="row">
              {{
                checkName(
                  row.item.answerId.anonymousResponse,
                  row.item.answerId.name,
                )
              }}
            </template>
            <template v-slot:cell(email)="row">
              {{
                checkEmailAndPhone(
                  row.item.answerId.anonymousResponse,
                  row.item.answerId.email,
                )
              }}
            </template>
            <template v-slot:cell(phone)="row">
              {{
                checkEmailAndPhone(
                  row.item.answerId.anonymousResponse,
                  row.item.answerId.phone,
                )
              }}
            </template>
            <template v-slot:cell(feedback)="row">
              {{
                !row.item.answerId.anonymousResponse
                  ? row.item.feedback
                  : '**********'
              }}
            </template>
            <template
              v-slot:cell(restore)="row"
              v-if="userProfile.permissions.trash.undo_answer"
            >
              <div class="option">
                <button
                  :title="`${$t('trash.answersMenu.answersInfo')}`"
                  v-b-modal="`modal-${row.index}`"
                  class="btn btn-outline-primary"
                >
                  <i class="fas fa-search"></i>
                  <modal-addquestions-trash
                    :id="row.index"
                    :customer="row.item"
                  />
                </button>
                <button
                  :title="`${$t('trash.answersMenu.answersRestore')}`"
                  class="btn btn-outline-primary"
                  @click="restore('answer', row.item._id)"
                >
                  <i class="fas fa-trash-restore-alt"></i>
                </button>
              </div>
            </template>
          </b-table>
          <div class="col-12 text-right">
            <span
              @click="exportToXLSX('xlsx')"
              :title="`${$t('trash.answersMenu.exportXLS')}`"
              class="xls"
            >
              <i class="fas fa-file-excel"></i>
            </span>
          </div>
          <paginate
            :pageCount="Math.ceil(totalAnswers / limit)"
            v-model="page"
            :clickHandler="changeAnswerData"
            :prevText="'‹'"
            :nextText="'›'"
            :activeClass="'active'"
            :containerClass="'pagination b-pagination'"
            :pageClass="'page-item'"
          >
          </paginate>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import tabs from '@/components/molecules/idx-tabs';
import modalAddquestionsTrash from '@/components/molecules/modal-addquestions-trash';
import dashboardBar from '@/components/molecules/dashboard-bar';
import eventBus from '../../../eventBus';
import api from '../../../services/api';
import Vue from 'vue';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

Vue.use(PerfectScrollbar);

export default {
  name: 'Trash',

  components: {
    tabs,
    Paginate,
    modalAddquestionsTrash,
    dashboardBar,
  },

  data: () => ({
    loading: false,
    limit: 10,
    totalAnswers: null,
    userAuth: null,
    step: 1,
    filter: null,
    dates: {
      start: null,
      end: null,
    },
    page: 1,
    itemsAnswers: [],
    itemsActions: [],
    actionsFields: [],
    answersFields: [],
    items: [],
    formattedDate: {
      start: null,
      end: null,
    },
  }),

  watch: {
    myActionId: function watchMyActionId() {
      this.setData();
    },
    myActionsIds: function watchMyActionsIds() {
      this.setData();
    },
    actionGroupData: function watchactionGroup() {
      this.setData();
    },
    myIh1: function watchMyIh1() {
      this.setData();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.setData();
    },
    myIh2: function watchMyIh1() {
      this.setData();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.setData();
    },
    dates: function watchCalendarDates() {
      this.page = 1;
      this.setAnswerData();
    },
    calendarDates: function watchCalendarDates() {
      this.setData();
    },
  },

  computed: {
    ...mapState('answers', ['trash']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('authentication', ['userProfile']),
    ...mapState('calendar', ['calendarDates']),
  },

  methods: {
    ...mapActions('answers', ['setTrashActions']),
    ...mapActions('trash', ['restoreAction']),

    checkUser(user) {
      if (user) {
        return user.name;
      }
      return '-';
    },

    checkName(anonymous, name) {
      if (anonymous && !this.userProfile.permissions.trash.anonymous_profile) {
        return 'Anônimo';
      } else if (this.userProfile.permissions.trash.anonymous_profile) {
        return '*****';
      } else if (name) {
        return name;
      }
      return '-';
    },

    checkEmailAndPhone(anonymous, value) {
      if (anonymous && !this.userProfile.permissions.trash.anonymous_profile) {
        return 'Anônimo';
      } else if (this.userProfile.permissions.trash.anonymous_profile) {
        return '***************';
      } else if (value) {
        return value;
      }
      return '-';
    },

    async exportToXLSX(type) {
      try {
        await api.get(
          `recyclebins/download/${this.userAuth.companyId}/${type}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              actionId:
                this.myActionsIds.length === 0
                  ? null
                  : this.myActionsIds.join(','),
              groupId: this.actionGroupData._id,
              startDate: this.calendarDates.start,
              endDate: this.calendarDates.end,
              ih1:
                this.myHierarchies1.length === 0
                  ? null
                  : this.myHierarchies1.join(','),
              ih2:
                this.myHierarchies2.length === 0
                  ? null
                  : this.myHierarchies2.join(','),
              filter: this.filter,
            },
          },
        );

        swal({
          title: this.$t('trash.answersMenu.swExport.title'),
          text: this.$t('trash.answersMenu.swExport.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: `${this.$t('trash.answersMenu.swError.title')}...`,
          text: error.response.data.message,
          icon: 'error',
        });
      }
    },

    cleanFilter() {
      this.filter = null;
      this.setAnswerData();
    },

    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        clearTimeout(this.typingTimer);

        this.typingTimer = setTimeout(this.setAnswerData, 600);
      }

      if (this.filter === '') {
        this.filter = null;
        this.setAnswerData();
      }
    },

    async setData(page) {
      this.loading = true;

      this.setAnswerData();

      await this.setTrashActions({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId:
          this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        groupId: this.actionGroupData._id,
        startDate: this.dates.start,
        endDate: this.dates.end,
        ih1:
          this.myHierarchies1.length === 0
            ? null
            : this.myHierarchies1.join(','),
        ih2:
          this.myHierarchies2.length === 0
            ? null
            : this.myHierarchies2.join(','),
        page: page || this.page,
        limit: 10,
      }).then(() => {
        this.itemsActions = this.trash.actions.items;
        this.loading = false;
      });
    },

    async setAnswerData() {
      this.loading = true;

      const response = await api.get(
        `/recyclebins/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
            groupId: this.actionGroupData._id,
            page: this.page,
            limit: 10,
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            ih1:
              this.myHierarchies1.length === 0
                ? null
                : this.myHierarchies1.join(','),
            ih2:
              this.myHierarchies2.length === 0
                ? null
                : this.myHierarchies2.join(','),
            filter: this.filter,
          },
        },
      );
      this.itemsAnswers = response.data.recycleBins;
      this.totalAnswers = response.data.totalAnswers;
      this.page = response.data.page;

      this.loading = false;
    },

    async changePageActions(page) {
      await this.setTrashActions({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId:
          this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        groupId: this.actionGroupData._id,
        startDate: this.dates.start,
        endDate: this.dates.end,
        ih1:
          this.myHierarchies1.length === 0
            ? null
            : this.myHierarchies1.join(','),
        ih2:
          this.myHierarchies2.length === 0
            ? null
            : this.myHierarchies2.join(','),
        page,
        limit: 10,
      }).then(() => {
        this.itemsActions = this.trash.actions.items;
      });
    },

    async changeAnswerData() {
      this.loading = true;
      await this.setAnswerData();
      this.loading = false;
    },

    dateFormat(param) {
      const date = format(new Date(param), 'dd/MM/yyyy HH:mm', { locale: pt });
      return date;
    },

    changeOption(event, step) {
      const $li = document.querySelector('.menu-active');
      $li.classList.remove('menu-active');
      event.target.classList.add('menu-active');
      this.step = step;
    },

    restore(type, id) {
      let objAction;

      switch (type) {
        case 'action': {
          swal({
            title: this.$t('trash.answersMenu.swQuestion.title'),
            text: this.$t('trash.answersMenu.swAction.description'),
            icon: 'warning',
            buttons: true,
            dangerMode: true,
          }).then(async (willDelete) => {
            if (willDelete) {
              objAction = { type, id, token: this.userAuth.token };
              await this.restoreAction(objAction);
              swal(this.$t('trash.answersMenu.swRestore.description'), {
                icon: 'success',
              });

              await this.setData();
            }
          });

          break;
        }
        case 'answer': {
          swal({
            title: this.$t('trash.answersMenu.swQuestion.title'),
            text: this.$t('trash.answersMenu.swAnswer.description'),
            icon: 'warning',
            buttons: true,
            dangerMode: true,
          }).then(async (willDelete) => {
            if (willDelete) {
              try {
                const response = await api.delete(`/recyclebins/${id}`, {
                  headers: { 'x-access-token': this.userAuth.token },
                });
                swal(`${response.data.msg}`, {
                  icon: 'success',
                });

                await this.setAnswerData();
              } catch (error) {
                swal({
                  title: `${this.$t('trash.answersMenu.swError.title')}...`,
                  text: error.response.data.message,
                  icon: 'error',
                });
              }
            }
          });
          break;
        }
        default: {
          return false;
        }
      }
      return true;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.actionsFields = [
      {
        key: 'name',
        label: this.$t('trash.actionsMenu.actionsTable.labels.action'),
      },
      {
        key: 'updatedAt',
        label: this.$t('trash.actionsMenu.actionsTable.labels.date'),
      },
      {
        key: 'deletedBy.name',
        label: this.$t('trash.actionsMenu.actionsTable.labels.user'),
      },
    ];

    this.answersFields = [
      {
        key: 'actionId',
        label: this.$t('trash.answersMenu.answersTable.labels.action'),
      },
      {
        key: 'answerId',
        label: this.$t('trash.answersMenu.answersTable.labels.id'),
      },
      {
        key: 'updatedAt',
        label: this.$t('trash.answersMenu.answersTable.labels.date'),
      },
      {
        key: 'userId',
        label: this.$t('trash.answersMenu.answersTable.labels.user'),
      },
      {
        key: 'client',
        label: this.$t('trash.answersMenu.answersTable.labels.client'),
      },
      {
        key: 'email',
        label: this.$t('trash.answersMenu.answersTable.labels.email'),
      },
      {
        key: 'phone',
        label: this.$t('trash.answersMenu.answersTable.labels.phone'),
      },
      {
        key: 'answerId.feedback',
        label: this.$t('trash.answersMenu.answersTable.labels.feedback'),
        thStyle: { width: '20%' },
      },
      {
        key: 'reason',
        label: this.$t('trash.answersMenu.answersTable.labels.reason'),
        thStyle: { width: '180px' },
      },
    ];

    if (!this.userProfile.permissions.trash.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }

    if (this.userProfile.permissions.trash.undo_action) {
      this.actionsFields.push({
        key: 'restore',
        label: this.$t('trash.actionsMenu.actionsTable.labels.restore'),
      });
    }

    if (this.userProfile.permissions.trash.undo_answer) {
      this.answersFields.push({
        key: 'restore',
        label: this.$t('trash.answersMenu.answersTable.labels.options'),
      });
    }

    this.setAnswerData();
  },

  mounted() {
    this.setData();
    eventBus.$on('change-dates', (dates) => {
      this.dates = dates;
    });
  },

  async beforeDestroy() {
    eventBus.$off('change-dates');
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.wrapper {
  padding: 8px;
}

.wrapper-trash {
  background-color: $white;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid $gray-light;
  .btn-outline-primary {
    &:hover {
      color: #fff;
    }
  }
  .nav-menu {
    list-style-type: none;
    margin: 0;
    padding: 0;

    li {
      display: inline;
    }

    a {
      padding: 15px 25px;
      font-weight: bold;
      color: $secondary;
      text-transform: uppercase;
      &:hover {
        cursor: pointer;
      }
    }

    .menu-active {
      border-bottom: 3px solid $primary;
    }
  }
}

.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-enter {
  opacity: 0;
}

.option {
  min-width: 90px;
}

.content-tab {
  border-top: 1px solid $gray-light;
  padding: 16px;
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

.calendar-icon {
  color: #4ce595;
  cursor: pointer;
  &:hover {
    color: rgb(97, 209, 97);
    ~ .calendar {
      display: block;
    }
  }
}
</style>

<style scoped>
.wrapper-trash .content-tab >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style lang="scss">
.wrapper-trash .content-tab .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.wrapper-trash .content-tab a {
  outline: none;
}
.fa-trash-restore {
  cursor: pointer;
}

.search-actions {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/trash/index.vue